"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _excluded = ["id", "name", "component", "isMain"];

var FiltersMenu = function FiltersMenu(_ref) {
  var areFiltersOpenFromFilterPill = _ref.areFiltersOpenFromFilterPill,
      selectedFilter = _ref.selectedFilter,
      appliedFilters = _ref.appliedFilters,
      filters = _ref.filters,
      onFilterClick = _ref.onFilterClick,
      onFilterBack = _ref.onFilterBack,
      onApplyFilters = _ref.onApplyFilters,
      onCancelFilters = _ref.onCancelFilters,
      onLoad = _ref.onLoad,
      dataTrackType = _ref.dataTrackType,
      dataElementName = _ref.dataElementName;
  var match = filters.find(function (filter) {
    return filter.type === 'filter' && filter.id === selectedFilter;
  });

  if (match) {
    var _ref2 = match,
        _id = _ref2.id,
        name = _ref2.name,
        FilterSelectorComponent = _ref2.component,
        isMain = _ref2.isMain,
        otherProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    if (!FilterSelectorComponent) return null;
    var applyButtonTrackProps = dataTrackType ? {
      'data-track-type': "".concat(dataElementName, " apply button"),
      'data-element-name': dataTrackType
    } : {};
    var cancelButtonTrackProps = dataTrackType ? {
      'data-track-type': "".concat(dataElementName, " cancel button"),
      'data-element-name': dataTrackType
    } : {};
    return (0, _preact.h)("div", null, areFiltersOpenFromFilterPill || isMain ? (0, _preact.h)("div", {
      className: "overview__filters-box-header"
    }, name) : (0, _preact.h)("div", {
      className: "overview__filters-box-header-back",
      onClick: function onClick() {
        return onFilterBack();
      }
    }, (0, _preact.h)(_assets.default, {
      width: 20,
      height: 20,
      icon: "chevronLeft"
    }), (0, _preact.h)("div", null, name)), (0, _preact.h)("div", null, (0, _preact.h)(FilterSelectorComponent, (0, _extends2.default)({
      id: _id,
      name: name,
      selectedFilterItems: (appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters[_id]) === false ? false : (appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters[_id]) || [],
      onLoad: onLoad
    }, otherProps), function (_ref3) {
      var isApplyButtonDisabled = _ref3.isApplyButtonDisabled,
          data = _ref3.data;
      return (0, _preact.h)("div", null, (0, _preact.h)("hr", null), (0, _preact.h)("div", {
        className: "overview__filters-box-buttons"
      }, (0, _preact.h)(_Button.default, (0, _extends2.default)({
        size: "small",
        variant: "brand",
        title: "Apply",
        disabled: isApplyButtonDisabled,
        onClick: function onClick() {
          return onApplyFilters(_id, data);
        }
      }, applyButtonTrackProps)), (0, _preact.h)(_Button.default, (0, _extends2.default)({
        size: "small",
        title: "Cancel",
        onClick: function onClick() {
          return onCancelFilters();
        }
      }, cancelButtonTrackProps))));
    })));
  }

  return (0, _preact.h)("div", null, filters.filter(function (filter) {
    return filter.type !== 'filter' || !filter.isMain;
  }).map(function (filter, index) {
    if (filter.type === 'separator') {
      return (0, _preact.h)("hr", {
        key: index,
        className: "separator"
      });
    }

    if (filter.type === 'text') {
      return (0, _preact.h)("div", {
        className: "overview__filters-box-text",
        key: filter.id
      }, filter.name);
    }

    return (0, _preact.h)("div", {
      className: "overview__filters-box-filter qa-".concat(filter.id, "-selector"),
      key: filter.id,
      onClick: function onClick() {
        return onFilterClick(filter.id);
      }
    }, (0, _preact.h)("span", null, filter.name));
  }));
};

var _default = FiltersMenu;
exports.default = _default;